import { observer } from 'mobx-react';
import Main from '../../../../../../BrowserSupport/Main';
import Notifications from '../../../../../../Notifications';
import I18nTitle from '../../../../../../Title/I18nTitle';
import withRouter from '../../../WithRouter';
import Builder from './Builder';
interface Props {
  params: { id: string };
}

function BuilderV2Edit({ params }: Props) {
  return (
    <>
      <I18nTitle title="Edit a collection - AdminStudio" />
      <div>
        <Notifications />
        <Main
          id="main"
          className="min-h-[calc(100vh-230px)] max-w-clientPortalMaxWidth w-full mx-auto"
        >
          <Builder id={params.id} />
        </Main>
      </div>
    </>
  );
}

export default withRouter(observer(BuilderV2Edit));
